import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ReferenceParams, Res } from 'src/app/models';
import { LanguageService, ApiKaspiPricesService, NotificationService, ApiProductsService, ValidatorsService } from 'src/app/services';
import { KaspiPriceEditValidator } from './kaspi-price-edit.validator';

@Component({
  selector: 'app-kaspi-price-edit',
  templateUrl: './kaspi-price-edit.component.html',
  styleUrls: ['./kaspi-price-edit.component.css']
})
export class KaspiPriceEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  products: any[] = [];
  priceProduct: any[] = [];
  priceId: string;
  price: any;
  selectedOffers: any[] = [];
  offers: any[] = [];
  offerParams: any;
  deletedOffersId: string[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  errorMessages: any;

  form: UntypedFormGroup = this.fb.group({
    id:              [null],
    offers:          this.fb.array([]),
    deletedOffersId: [null]
  });

  

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiKaspiPrices: ApiKaspiPricesService,
    private apiProducts: ApiProductsService,
    private notification: NotificationService,
    private fb: UntypedFormBuilder,
    private currentRoute: ActivatedRoute,
    private validator: KaspiPriceEditValidator,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.priceId = this.currentRoute.snapshot.paramMap.get('id');
    this.errorMessages = this.validator.errorMessages;
    this.language = this.languageService.getLanguage();

    this.onEdit();
    this.getProducts();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  
  /**
   * 
   */
  initForm(): void {

    this.form.controls.id.setValue(this.priceId);

    for(let offer of this.offers){

      this.addOffer(offer);
    }
  }


  /**
   * 
   * @param type string
   */
  addOffer(offer: any = null): void {

    let control = this.form.controls.offers as UntypedFormArray;
    control.insert(0, this.initOffer(offer)); // insert 0 - вставка в начала массива / push - вставка в конец массива

    if(offer != null){

      for(let i = 0; i < offer.availabilities.length; i++){

        this.addAvailability(0); // использовать если выше используется push - (this.form.controls.offers.value.length - 1)
      }
    }
    else{
      
      this.addAvailability(0);   // использовать если выше используется push - (this.form.controls.offers.value.length - 1)
      
      // необходимость ... для корректной работы checkbox
      let o = {...offer}; 
      o['checked'] = false;
      this.offers.unshift(o);
    }
  }


  /**
   * 
   * @returns 
   */
  initOffer(offer: any = null): any {

    return this.fb.group({
      id:             [offer != null ? offer.id : null],
      product_id:     [offer != null ? offer.product_id : null, this.validator.product_id],
      price:          [offer != null ? offer.price : null, this.validator.price],
      availabilities: this.fb.array([])
    });
  }


  /**
   * 
   * @param i number
   */
  removeOffer(i: number): void {

    if(this.form.get(['offers', i, 'id']).value != null){

      this.deletedOffersId.push(this.form.get(['offers', i, 'id']).value);
      this.form.controls.deletedOffersId.setValue(this.deletedOffersId);
    }

    let control = this.form.controls.offers as UntypedFormArray;
    control.removeAt(i);

    this.getProducts();
  }


  /**
   * 
   * @param type string
   */
  addAvailability(i): void {

    let control = this.form.get(['offers', 0, 'availabilities']) as UntypedFormArray;
    control.push(this.initAvailability(i));
  }


  /**
   * 
   * @returns 
   */
  initAvailability(i): any {

    return this.fb.group({
      available: 'yes', 
      storeId:   'pp' + (this.form.get(['offers', i, 'availabilities']).value.length + 1)
    });
  }


  /**
   * 
   * @param i number
   */
  removeAvailability(i: number, j: number): void {

    let control = this.form.get(['offers', i, 'availabilities']) as UntypedFormArray;
    control.removeAt(j);
  }


  /**
   * 
   */
  resetForm(): void {

    this.form.reset();

    for(let offer of this.form.controls.offers.value){

      this.removeOffer(0);
    }

    this.deletedOffersId = [];
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiKaspiPrices.info(this.priceId).subscribe((response: Res) => { console.log('[RESPONSE] getPriceList: ', response);

        if(response != null){

          this.price = response.result;
          this.getOffers();
        }
        else{

          this.addOffer();
        }

        this.progressRef.complete();
      },
      error =>{

        this.addOffer();
        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  getProducts(searchValue: string = '', action: string = ''): void {

    let params: ReferenceParams = {
      filter: {
        name: searchValue
      }
    }

    this.loading = true;
    this.products = [];

    this.subscriptions.add(
      this.apiProducts.getReferences(params, 'products').subscribe((response: Res) => { console.log('[RESPONSE] getProducts: ', response);

        if(response != null){

          let list: any[] = [];

          if(action){

            let offers: any[] = this.form.get('offers').value;

            for(let prod of response.result){

              if(offers.findIndex(val => val.product_id == prod.id) == -1){

                list.push({...prod});
              }
            }
          }
          
          this.products = action ? [...list] : [...response.result];
        }

        this.loading = false;
      },
      error => {
        this.loading = false;
        this.products = [];
      })
    );
  }


  /**
   * 
   */
  getOffers(): void {

    this.progressRef.start();
    this.loading = true;
    this.offers = [];

    this.setOfferParams();

    this.subscriptions.add(
      this.apiKaspiPrices.getOffers(this.priceId, this.offerParams).subscribe((response: Res) => { console.log('[RESPONSE] getOffers: ', response);

        if(response != null){

          if(response.result != null){
          
            this.offers = response.result.list;

            this.initForm();
            this.getProducts();
  
            this.paginationInput = {
              count:          response.result.count,
              numberOfPages:  response.result.numberOfPages,
              currentPage:    this.offerParams.pageNumber,
              size:           this.offerParams.countOnPage
            }

            for (let offer of this.offers) {

              offer['checked'] = false;
            }
          }
          else{

            this.addOffer();
          }
        }
        else{

          this.addOffer();
        }
  
        this.progressRef.complete();
        this.loading = false;
      },
      error => { 
        this.progressRef.complete();
        this.loading = false;
        this.addOffer();
      })
    );
  }


  /**
   * 
   */
  setOfferParams(): void {

    this.offerParams = {
      filter: {},
      pageNumber:  (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {
    
    this.paginationOutput = event;
    this.resetForm();
    this.onEdit();
  }


  /**
   * 
   */
  onUpdate(): void {

    this.progressRef.start();

    let data = {...this.form.value};

    for(let offer of data.offers){

      offer.price = +offer.price;
    }

    this.subscriptions.add(
      this.apiKaspiPrices.save(data).subscribe((response: Res) => { console.log('[RESPONSE] updateOffer: ', response);

        if(response != null){

          this.resetForm();
          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }
  
        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  sendContent(): void {

    let data = {
      price_list_id: null, // если нужно отправить все продукты тогда нужно вставить ID прайс-листа
      products_id: []
    }

    // проверка выбранны ли все элементы
    if(this.selectedOffers.length == this.offers.length){

      data.price_list_id = this.priceId;
      data.products_id = [];
    }
    else{

      data.price_list_id = null;
      data.products_id = [...new Set(this.selectedOffers.map( ({ id }) => id ))];
    }

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiKaspiPrices.importProducts(data).subscribe((response: Res) => { console.log('[RESPONSE] importProducts: ', response);

        if(response != null){

          this.notification.show('success', 'Данные успешно отправлены!');
        }
  
        this.progressRef.complete();
        this.loading = false;
        this.checkAllCheckBox({ target: { checked: false }});
      },
      error => { 
        this.progressRef.complete();
        this.loading = false;
        this.checkAllCheckBox({ target: { checked: false }});
      })
    );
  }



  /* CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.offers[index].checked = event.target.checked;
    this.selectedOffers = this.offers.filter(val => val.checked);
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.offers.forEach(x => {

      if(x.id != null){

        x.checked = event.target.checked
      }
    });

    this.selectedOffers = event.target.checked ? this.offers.filter(val => val.checked) : [];
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.offers.length == 0) return false;

    return this.offers.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.offers.length;
    let pc = this.offers.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.offers.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


  /* VALIDATION */

  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.form.get(field));
  }
}
